import { render, staticRenderFns } from "./TeamRosterV2.vue?vue&type=template&id=5f9cb88b&"
import script from "./TeamRosterV2.vue?vue&type=script&lang=ts&"
export * from "./TeamRosterV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports